





















import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';

export interface IOption {
  label?: string;
  value: string;
  disabled: boolean;
}

@Component<Radio>({
  computed: {
    isChecked() {
      return this.modelValue === this.value;
    }
  }
})
export default class Radio extends Vue {
  @Model('change', { default: '' }) modelValue?: string;

  @Prop() name!: string;
  @Prop() label!: string;
  @Prop({ default: '' }) value?: string;
  @Prop() disabled!: string;
}
